<template>
<div>
  <v-layout row wrap>
    <v-flex v-if='showScheduleBlock' xs12 sm5 >
      <transition name='fade' mode="out-in" >
        <schedule
          :date='date'
          :schedule='homepage'
          :appointment='currentAppointment'
          :loading='scheduleRequest.loading'
          @today='gotoToday()'
          @previous='changeDate(-1)'
          @next='changeDate(1)'
          @previous:week='changeDate(-7)'
          @next:week='changeDate(7)'
          @date='setDate'
          @selected='setCurrentAppointment'
          @close='listSpaceIndex = 0'
          class='pb-0' >
        </schedule>
      </transition>
    </v-flex>

    <v-flex v-if='!$vuetify.breakpoint.xs' class='hidden-xs' xs12 :sm12='!showScheduleBlock' :sm7='showScheduleBlock' md7 >
      <v-toolbar dense class='mb-2' >
        <!-- <v-toolbar-title class='mr-2' >Quick links</v-toolbar-title>
         -->
        <template v-if='$vuetify.breakpoint.xl' >
          <v-toolbar-side-icon >
            <v-icon color='amber' >flash_on</v-icon>
          </v-toolbar-side-icon>
          <v-divider vertical ></v-divider>
        </template>
        <v-btn flat to='/calendar' >Calendar</v-btn>
        <v-btn flat to='/clients' >Clients</v-btn>
        <v-btn flat to='/invoices' >Invoices</v-btn>
        <v-btn flat to='/reports' >Reports</v-btn>
        <v-spacer></v-spacer>
        <birthday-bar ></birthday-bar>
      </v-toolbar>
      <!-- <pre v-text="scheduleRequest" class="caption grey lighten-4 pa-3" /> -->
      <!-- <onboardlet ></onboardlet> -->
      <home-detail class='mt-2'
        @close='currentAppointment=null'
        @chart:appointments:clicked='chartClicked'
        :homepage='homepage'
        :appointment='currentAppointment'
        :loading='scheduleRequest.loading' >
      </home-detail>
    </v-flex>
  </v-layout>

  <!-- <v-card><pre>{{currentAppointment}}</pre></v-card> -->

</div>
</template>
<script>
import moment from 'moment'

import HomeDetail from '@/components/home/Detail'
// import Onboardlet from '@/components/home/Onboardlet'
import Schedule from '@/components/calendar/Schedule'
import BirthdayBar from '@/components/lists/BirthdayBar'
import {mapGetters} from 'vuex'
import {
  LIST_APPOINTMENTS_IN_RANGE_REQ
} from '@/store/constants'

export default {
  name: 'HomePage',
  components: {Schedule, HomeDetail, BirthdayBar},
  data () {
    return {
      now: moment(),
      ready: false,
      viewHomePage: true,
      activeClient: null,
      currentAppointment: null,
      // currentTime: moment().format('HH:mm'),
      date: moment().format('YYYY-MM-DD'),
      reqIds: {
        list: 'homepage-list-request'
      }
    }
  },
  mounted () {
    // let vm = this
    // setInterval(() => {
    //   vm.currentTime = moment().format('HH:mm')
    // }, 60000)
    this.refresh()
  },
  computed: {
    ...mapGetters(['me', 'isLoggedIn']),
    showScheduleBlock () {
      if (this.appPlatform === 'ios' && this.$vuetify.breakpoint.sm) {
        return false
      }
      return true
    },
    appointmentsRequest () {
      return this.$store.getters.getRequestById(LIST_APPOINTMENTS_IN_RANGE_REQ, true)
    },
    appointmentsRequestModified () {
      return this.appointmentsRequest.modified
    },
    scheduleRequest () {
      let result = this.$store.getters.getRequestById(this.reqIds.list, true)
      return result
    },
    homepage () {
      return this.getObjectPath(this.scheduleRequest, 'result.data', {})
    }
  },
  watch: {
    '$route': 'refresh',
    // isLoggedIn () {
    //   if (this.isLoggedIn) { this.refresh() }
    // },
    date () {
      this.getSchedule()
    },
    appointmentsRequestModified () {
      this.getSchedule()
    },
    currentAppointment () {
      let activeClientId = null
      if (this.activeClient) {
        activeClientId = this.activeClient.id
      }
      if (this.currentAppointment &&
        this.currentAppointment.client &&
        this.currentAppointment.client !== activeClientId) {
        this.activeClient = {
          id: this.currentAppointment.client,
          client: {}
        }
      }
    }
  },
  methods: {
    refresh () {
      this.getSchedule()
    },
    getSchedule () {
      let params = { date: this.date }
      this.$appointmentguru
        .resource('home')
        .id(this.reqIds.list)
        .list(params)
    },
    getAppointment (appointmentId) {
      this.$appointmentguru
        .resource('home')
        .id(this.reqIds.detail)
        .get(appointmentId)
    },
    setCurrentAppointment (appointment) {
      this.viewHomePage = false
      this.currentAppointment = appointment
      // this.getAppointment(appointment.id)
      if (this.$vuetify.breakpoint.xsOnly) {
        // this.listSpaceIndex = 1
      }
    },
    setCurrentAppointmentById (appointmentId) {
      // Need to also update the date though?
      this.viewHomePage = false
      this.getAppointment(appointmentId)
      if (this.$vuetify.breakpoint.xsOnly) {
        this.listSpaceIndex = 1
      }
    },
    chartClicked (point) {
      if (point && point.x) {
        this.setDate(point.x)
      }
    },
    setDate (date) {
      this.date = date
    },
    changeDate (count) {
      this.date = moment(this.date).add(count, 'days').format('YYYY-MM-DD')
    },
    gotoToday () {
      this.date = moment().format('YYYY-MM-DD')
    }
  },
  i18n: {
    messages: {
      en: {
        cards: {
          schedule: {
            title: ''
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?6ff242cc